import React from 'react';

import { useTranslations } from '@vk-hr-tek/core/hooks';

import { UserRoleEnum } from '@app/types';
import { SystemSectionItem } from '@app/gen/side_menu';
import { NavigationExternalItem } from '@app/router';
import { useSelector } from '@app/hooks';
import { modules } from '@app/modules';

import { AbilityProvider } from '../../../../layout';
import { Can } from '../../../../app/ability';
import { selectHasCompanySide } from '../../../../user';
import { SidebarMenu } from '../SidebarMenu';

interface SidebarSectionItemProps {
  item: SystemSectionItem;
  sidebarOpened: boolean;
  isSkeletonLoading: boolean;
  onMenuItemClick: (pageTitle: string) => void;
  additionalOptions?: Record<UserRoleEnum, NavigationExternalItem[]>;
}

export const SidebarSectionItem = ({
  item,
  sidebarOpened,
  isSkeletonLoading,
  onMenuItemClick,
  additionalOptions,
}: SidebarSectionItemProps) => {
  const { t } = useTranslations();
  const hasCompanySide = useSelector(selectHasCompanySide);

  const { children, nick } = item;
  const { resource, basename } = modules[nick];
  const role = nick.startsWith(UserRoleEnum.Company)
    ? UserRoleEnum.Company
    : UserRoleEnum.Employee;

  const abilityRole =
    hasCompanySide && role !== UserRoleEnum.Employee
      ? UserRoleEnum.Company
      : UserRoleEnum.Employee;

  const label = t(basename);
  return (
    <AbilityProvider role={abilityRole}>
      <Can do="read" on={resource}>
        <SidebarMenu
          menuLabel={label}
          sidebarOpened={sidebarOpened}
          skeletonLoading={isSkeletonLoading}
          key={nick}
          onMenuItemClick={onMenuItemClick}
          items={children}
          externalItems={additionalOptions?.[role]}
        />
      </Can>
    </AbilityProvider>
  );
};
